import AppSetting from '../../common/constants/appsetting.constant.js'
import axios from 'axios'
import UserTypeEnum from '../../common/enum/user-type.enum.js';
import StorageType from '../session/storage.enum.js';
import StorageService from '../session/storage.service.js';
import SettingsService from './settings.service.js';
import ThemeService from '../api/theme.service'

import { Navigate, useNavigate } from 'react-router-dom';
import CommonService from './common.service.js';

const LoginService = {
  getLoggedInData() {
    return JSON.parse(StorageService.get(StorageType.session, 'userDetails'));
  },  
  Navigate() {
    return useNavigate()
  },
  login(data) {
    return axios.post(AppSetting.common.login, data)
      .then((res) => { return res })
      .catch((err) => { return err.response })

  },
  unlockScreen(data) {
    return axios.post(AppSetting.common.unlockScreen, data)
      .then((res) => { 
        return res 
      })
      .catch((err) => { 
        return err.response 
      })

  },
  patientLogin(data) {
    let url = AppSetting.common.patientLogin
    return axios.post(url, data)
      .then(
        (res) => { return res }
      )
      .catch((err) => { return err }
      );
  },
  patientLoginOTP(data) {
    return axios.post(AppSetting.common.patientLoginOTP, data)
      .then(
        (res) => { return res }
      )
      .catch((err) => { return err }
      );
  },
  logOut() {
    let settingsData = JSON.parse(
      StorageService.get(StorageType.session, "settingsData")
    )
    console.log(settingsData)
    try {
      this.userName = "";
      StorageService.remove(StorageType.session, "userDetails");
      StorageService.remove(StorageType.session, "auth");
      StorageService.remove(StorageType.session, "roleDetails");
      StorageService.remove(StorageType.session, "settingsData");
      StorageService.remove(StorageType.session, "providerList");
      StorageService.remove(StorageType.session, "providerSelected");
      StorageService.remove(StorageType.session, 'moduleDetails');
      StorageService.remove(StorageType.session, 'locale');
      StorageService.remove(StorageType.session, 'guestUser');
      SettingsService.setSettingsData(undefined);
    } catch (Exception) {
      this.userName = "";
      StorageService.remove(StorageType.session, "userDetails");
      StorageService.remove(StorageType.session, "auth");
      StorageService.remove(StorageType.session, "roleDetails");
      StorageService.remove(StorageType.session, "settingsData");
      StorageService.remove(StorageType.session, "providerList");
      StorageService.remove(StorageType.session, "providerSelected");
      StorageService.remove(StorageType.session, 'moduleDetails');
      StorageService.remove(StorageType.session, 'locale');
      StorageService.remove(StorageType.session, 'guestUser');
      SettingsService.setSettingsData(undefined);
    }

    let user = CommonService.getLoggedInData()
    if (settingsData?.providerName && settingsData?.providerName != undefined) {
      if (user?.userType == 0) {
        return window.location.replace(`/patient/login/${settingsData.providerName}`)
      }
      else if(user?.userType ==1){
        return window.location.replace(`/login/${settingsData.providerName}`)
      }
      else{
        return window.location.replace(`/login`)
      }
    }
    else {
      if (user?.userType == 0) {
        return window.location.replace(`/patient/login`)
      }
      else {
        return window.location.replace(`/login`)
      }
    }
  },
  patientLoginViaOTP(data) {
    let url = AppSetting.common.patientLoginViaOTP
    return axios.post(url, data)
      .then(
        (res) => { return res }
      )
      .catch((err) => { return err }
      );
  },
  getloginUserData(userType, username, parentID) {
    let url;
    if (userType == 2) {
      url = AppSetting.common.getGlobalUserByUserName
        .replace('{username}', username);
    } else if (userType == 1) {
      url = AppSetting.common.getProviderUserByUserName
        .replace('{parentId}', parentID)
        .replace('{username}', username);
    } else if (userType === 0) {
      url = AppSetting.common.getPatientUserByUserName
        .replace('{parentId}', parentID)
        .replace('{username}', username);
    }
    return axios.get(url)
      .then(res => {
        return res
      }
      )
      .catch(err => { return err })
  },

  getProviderData(providerId) {
    let url = AppSetting.provider.globalGetProviderById.replace('{providerId}', providerId);
    return axios.get(url)
      .then(
        (res) => { console.log('get provider data', res.data); return res.data }
      )
      .catch((err) => { console.log(err); return err }
      );
  },
  getLogoTheme(providerName) {
    let providerSettings;
    if (providerName !== undefined) {
      return SettingsService.getProviderSettingsLogo(providerName)
        .then(responseLogo => {
          let oldSettingsData = JSON.parse(StorageService.get('session', 'settingsData'))
          return SettingsService.getProviderSettingsSkin(providerName)
            .then(responseSkin => {
              let SkinDetails = responseSkin;
              providerSettings = {
                logo: responseLogo.data.logo,
                skin: SkinDetails.data.skin,
                providerName: providerName,
                practiceLocationDetails:oldSettingsData?.practiceLocationDetails
              };
              StorageService.save(StorageType.session, "settingsData", JSON.stringify(providerSettings));
              ThemeService.changeTheme(SkinDetails.data.skin);
              // this.isLoaderTheme = false;
              // this.isLoaderLogo = false;
              return providerSettings
            })
            .catch(err => {
              console.log(err);
              ThemeService.changeTheme(7);
              // this.isLoaderTheme = false;
              // this.isLoaderLogo = false;
              return err
            })
        })
        .catch(err => {
          console.log(err);
          ThemeService.changeTheme(7);
          // this.isLoaderTheme = false;
          // this.isLoaderLogo = false;
          return ({ 'error': err })
        })
    }
  },

  getloginUserDetail(userType, username, parentID) {
    // console.log("uT", userType)
    // console.log("uN", username)
    // console.log("pID", parentID)
    let url;
    url = AppSetting.common.getProviderUserDetail
      .replace('{parentId}', parentID)
      .replace('{username}', username);
    return axios.get(url)
      .then(
        res => { console.log('fetched', res.data); return res.data }
      )
      .catch(err => {
        console.log(err); return err
      })
  }
}
export default LoginService